import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { accountKeys } from '@/lib/queries/account';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { BlockedClient } from './-components/BlockedClient';

const PAGE_SIZE = 100;

export const Route = createFileRoute('/_authed/settings/privacy/blocked/')({
  component: SettingsBlockedPage,
});

function SettingsBlockedPage() {
  const query = useQuery({
    ...accountKeys.blockedMembers({ pageSize: PAGE_SIZE }),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        eyebrow="Privacy"
        title="Block list"
        message="Could not load your block list."
        back={{ label: 'Privacy', href: '/settings/privacy' }}
      />
    );
  }
  if (query.isLoading) return null;
  return <BlockedClient pageSize={PAGE_SIZE} />;
}
